import APIService from '@/services/APIService.js';

export default {
  getIndicesCOGE() {
    return APIService.apiCall().get(`/indicesCOGE/getIndicesCOGE`);
  },
  getMesImportacao() {
    return APIService.apiCall().get(`/indicesCOGE/getMesImportacao`);
  },
  exibir(data_registro) {
    return APIService.apiCall().get(`/indicesCOGE/exibir/${data_registro}`);
  },
  importar(arquivoId) {
    return APIService.apiCall().get(`indicesCOGE/importar/${arquivoId}`);
  },
  processarImportacao(arquivoId) {
    return APIService.apiCall().get(`indicesCOGE/processarImportacao/${arquivoId}`);
  },
  deletar(data_registro) {
    return APIService.apiCall().get(`/indicesCOGE/excluir/${data_registro}`);
  },
  exportar(data_registro, config = {}) {
    return APIService.apiCall().get(`indicesCOGE/exportar/${data_registro}`, {
      responseType: 'blob',
      timeout: 60 * 60 * 1000,
      ...config
    });
  }
};
